import { KoobInputSelect } from '@koob/ui';
import { useApp } from 'hooks';

const LocaleSwitcher = ({
  queryLocale,
  updateQueryLocale,
  disabled,
  onChange,
}) => {
  const { locales } = useApp();

  // Flags are sized explicitly (same as KoobInputCountries rows) — left to
  // the font-size of the trigger they render a few pixels tall.
  const renderLocale = ({ label, alpha2 }) => (
    <div className="flex items-center gap-1.5">
      <span
        className={`flag-icon flag-icon-${alpha2} h-4 w-5 shrink-0 rounded-sm`}
      />
      <span className="whitespace-nowrap">{label}</span>
    </div>
  );

  return (
    <div className="w-36">
      <KoobInputSelect
        disabled={disabled}
        onValueChange={(newValue) =>
          (onChange || updateQueryLocale)(
            (locales ?? []).find((locale) => locale.value === newValue),
          )
        }
        value={queryLocale?.value ?? queryLocale}
        options={locales ?? []}
        renderValue={renderLocale}
        renderOption={renderLocale}
        data-testid="locale"
      />
    </div>
  );
};

export default LocaleSwitcher;
